const $ = require('jquery')
const Highcharts = require('highcharts')
const _ = require('lodash')
const moment = require('moment')
const Hammer = require('hammerjs')
const PullToRefresh = require('pulltorefreshjs')

require('highcharts/highcharts-more')(Highcharts)
require('highcharts/modules/boost-canvas')(Highcharts) // If a fallback is required, make sure to include boost-canvas.js, and that it's included before boost.js. C.f. https://assets.highcharts.com/errors/26/
require('highcharts/modules/boost')(Highcharts)
require('highcharts/modules/drilldown')(Highcharts)
require('highcharts/modules/accessibility')(Highcharts)
require('highcharts/modules/exporting')(Highcharts)
require('highcharts/modules/export-data')(Highcharts)
require('highcharts/modules/offline-exporting')(Highcharts)
require('highcharts/modules/no-data-to-display')(Highcharts)
require('highcharts/modules/solid-gauge')(Highcharts)

// moment locales are loaded via `moment-locales-webpack-plugin`
// c.f. config/webpack/webpack.config.js

module.exports = {
  $: $,
  jQuery: $,
  Highcharts: Highcharts,
  _: _,
  moment: moment,
  Hammer: Hammer,
  PullToRefresh: PullToRefresh
}

// export libs to global scope
// needed by 'legacy' JS code
for (const e in module.exports) {
  window[e] = module.exports[e]
}

try {
  moment.locale($('#main').data('user-datetime-locale') || 'en')
} catch (err) {
  console.error(err)
}
